import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';

const STORAGE_KEY = 'lumena_analytics_filters';

const handleStorageError = (operation: string, error: unknown): void => {
  if (process.env.NODE_ENV === 'development') {
    console.error(`Filter storage ${operation} failed:`, error);
  }
};

export const filterStorage = {
  save: (filters: BaseAnalyticsFilter): boolean => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
      return true;
    } catch (error) {
      handleStorageError('save', error);
      return false;
    }
  },

  load: (): BaseAnalyticsFilter | null => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return null;

      const parsed = JSON.parse(stored);

      if (parsed.startDate) {
        parsed.startDate = new Date(parsed.startDate);
      }
      if (parsed.endDate) {
        parsed.endDate = new Date(parsed.endDate);
      }

      return parsed;
    } catch (error) {
      handleStorageError('load', error);
      return null;
    }
  },

  clear: (): boolean => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      return true;
    } catch (error) {
      handleStorageError('clear', error);
      return false;
    }
  },

  isAvailable: (): boolean => {
    try {
      const testKey = '__test_storage__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  },
};
